import { encodePath } from "ufo";
function splitParallelPath(path, separator) {
  return path.split("/").reduce(
    (acc, p) => {
      const [names, paths] = acc;
      const sPath = p.split(separator);
      if (sPath.length >= 2) {
        const [spath, ...sname] = sPath;
        if (spath.length > 0 && spath !== "index")
          paths.push(spath);
        names.push(...sname);
      } else if (p !== "index") {
        paths.push(p);
      }
      return [names, paths];
    },
    [[], []]
  );
}
export function extractParallelRoutePath(path, separator = "@") {
  separator = encodePath(separator);
  const [names, paths] = splitParallelPath(path, separator);
  if (names.length === 0) {
    return;
  }
  return {
    name: names.join("/"),
    path: paths.join("/") || "/"
  };
}
export function overrideRoutePath(routePath, override) {
  const name = override?.name ?? routePath?.name;
  const path = override?.path ?? routePath?.path;
  if (name && path !== void 0)
    return { name, path };
}
